module.exports = "\n  <div *ngIf=\"pageData\" >\n    <div >Page Data is: {{pageData.Name}}</div>\n\n    Upload:\n    <p-fileUpload name=\"myfile[]\" url=\"http://localhost:35257/api/Page1/upload\" [accept]=\"text/xml\" auto=\"auto\"></p-fileUpload>\n\n  </div>\n       \n     \n \n\n"


//////////////////
// WEBPACK FOOTER
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/page1/page1.component.html
// module id = ../../../../../src/app/page1/page1.component.html
// module chunks = main